<div class="row filter-row">

  @if (canShowFilterStatus()) {
    <div class="col-lg-12">
      <label class="text-primary font-weight-bold">STATUS</label>
      @for (status of statusOptions(); track status.option) {
        <mat-checkbox class="d-block" [(ngModel)]="status.selected"
          (change)="updateStatus(status.option, $event)">
          {{ status.option }}
        </mat-checkbox>
      }
    </div>
  }

  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>PERÍODO</mat-label>
      <input
        matInput
        type="text"
        name="daterangeInput"
        class="date-range input-text"
        ngxDaterangepickerBootstrap
        [(ngModel)]="selectedDateRange"
        [ranges]="ranges"
        [alwaysShowCalendars]="true"
        [showCustomRangeLabel]="false"
        [showCancel]="true"
        [showDropdowns]="true"
        [autoApply]="false"
        [linkedCalendars]="true"
        (datesUpdated)="selectedDate($event)"
      />
      @if (hasPeriodSelected) {
        <mat-icon matSuffix class="period-clear-icon"
          (click)="clearPeriodRange(); $event.stopPropagation()">close</mat-icon>
      }
    </mat-form-field>
  </div>

  <div class="col-lg-12">
    <mat-form-field>
      <mat-label class="mat-label-class">BUSCAR VEÍCULO</mat-label>
      <input matInput [(ngModel)]="filter.searchQuery" (keydown.enter)="onSearchEnter($event); false">
      <mat-icon matSuffix (click)="submitFilter()" class="cursor-pointer">search</mat-icon>
    </mat-form-field>
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO DE VEÍCULO</label>
    <div class="row pr-3 d-flex justify-content-between mt-2">
      @for (segment of allSegments; track segment.segment) {
        <div class="col-4 col-md-4">
          <div class="card text-center card-type-vehicle-filter"
            [ngClass]="{'selected': isSegmentSelected(segment.segment)}"
            (click)="changeSegment(segment.segment)">
            <i class="d-block mx-auto text-primary cursor-pointer" [ngClass]="segment.iconClass"></i>
            {{ segment.segmentLabel }}
          </div>
        </div>
      }
    </div>
  </div>

  <div class="col-lg-12 mt-4">
    <mat-form-field>
      <mat-label>UNIDADE</mat-label>
      <input type="text" matInput [formControl]="evalDealerControl" [matAutocomplete]="evalDealerAutoComplete"
        (keydown.enter)="checkResetEvalDealer()" />
      <mat-autocomplete #evalDealerAutoComplete="matAutocomplete"
        (optionSelected)="selectEvalDealer($event.option.value)">
        @for (option of evalDealerOptions(); track option.id) {
          <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  @if (canShowPricingUserFilter() && pricingUserOptions().length > 0) {
    <div class="col-lg-12 mt-4">
      <mat-form-field style="width: 100%;">
        <mat-label>PRECIFICADOR</mat-label>
        <mat-select [formControl]="pricingUserControl" multiple (closed)="applyPricingUserFilter()">
          @for (user of pricingUserOptions(); track user.id) {
            <mat-option [value]="user.id">
              {{ user.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  
  @if (canShowPricingUserFilter() && filter.pricingUserIds?.length) {
    <div class="col-md-12">
      <mat-chip-listbox>
        @for (userId of filter.pricingUserIds; track userId) {
          <mat-chip-option [selectable]="false" [removable]="true" (removed)="removePricingUser(userId)">
            {{ getPricingUserName(userId) }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  }

  <div class="col-lg-12 mt-4">
    <div class="row">
      <div class="col-md-4">
        <mat-form-field style="width: 100%;">
          <mat-label>UF</mat-label>
          <mat-select [formControl]="ufControl" multiple (selectionChange)="selectUf($event)">
            <mat-option></mat-option>
            @for (state of states; track state.uf) {
              <mat-option [value]="state.uf">
                {{ state.uf }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-8">
        <mat-form-field style="width: 100%;">
          <mat-label>CIDADE</mat-label>
          <input type="text" matInput [formControl]="cityControl" [matAutocomplete]="cityAutoComplete" />
          <mat-autocomplete #cityAutoComplete="matAutocomplete" (optionSelected)="selectCity($event.option.value)">
            @for (option of cityOptions(); track option.id) {
              <mat-option [value]="option">
                {{ option.name }} - {{ option.uf }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>

  @if (filter.ufs?.length) {
    <div class="col-md-12">
      <mat-chip-listbox>
        @for (uf of filter.ufs; track uf) {
          <mat-chip-option
            [selectable]="false"
            [removable]="true"
            (removed)="removeUf(uf)">
            {{ uf }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  }

  @if (selectedCities().length > 0) {
    <div class="col-md-12" style="margin-top: 4px;">
      <mat-chip-listbox>
        @for (city of selectedCities(); track city.id) {
          <mat-chip-option
            [selectable]="false"
            [removable]="true"
            (removed)="removeCity(city.id)">
            {{ city.name }} - {{ city.uf }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  }

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO</label>
    @for (type of allEvalTypes; track type) {
      <mat-checkbox class="d-block" [checked]="isTypeSelected(type)"
        (change)="toggleType(type)">
        {{ getEvalTypeLabel(type) }}
      </mat-checkbox>
    }
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO DE PROPRIETÁRIO</label>
    @for (type of allOwnerTypes; track type) {
      <mat-checkbox class="d-block" [checked]="isOwnerTypeSelected(type)"
        (change)="toggleOwnerType(type)">
        {{ getOwnerTypeLabel(type) }}
      </mat-checkbox>
    }
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">STATUS DE ATENDIMENTO</label>
    @for (status of allStatusNegotiation(); track status) {
      <mat-checkbox class="d-block" [checked]="isStatusSelected(status)"
        (change)="toggleStatus(status)">
        {{ getNegotiationStatus(status) }}
      </mat-checkbox>
    }
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">RESGATE</label>
    <mat-checkbox class="d-block"
      [checked]="isRescueStatusSelected(rescueSentToStoreStatus)"
      (change)="toggleRescueStatus(rescueSentToStoreStatus)">
      {{ rescueSentToStoreLabel }}
    </mat-checkbox>
  </div>

  @if (hasResyncIntegrationErrorPermission()) {
    <div class="col-lg-12 mt-4">
      <label class="text-primary font-weight-bold">INTEGRAÇÃO</label>
      <mat-checkbox class="d-block" [(ngModel)]="filter.hasIntegrationError" (change)="submitFilter()">
        Com erro
      </mat-checkbox>
    </div>
  }

  @if (isFastQuoteSelected) {
    <div class="col-lg-12 mt-4">
      <label class="text-primary font-weight-bold">COTAÇÃO RÁPIDA</label>
      @for (status of allFastQuoteOfferStatus; track status) {
        <mat-checkbox class="d-block"
          [checked]="isStatusFastQuoteSelected(status)" (change)="toggleFastQuoteStatus(status)">
          {{ getFastQuoteStatus(status) }}
        </mat-checkbox>
      }

      @for (status of allFastQuoteNoOfferStatus; track status) {
        <mat-checkbox class="d-block"
          [checked]="isStatusFastQuoteSelected(status)" (change)="toggleFastQuoteStatus(status)">
          {{ getFastQuoteStatus(status) }}
        </mat-checkbox>
      }
    </div>
  }

</div>
